import { ref } from 'vue'

// État partagé entre la topbar et le widget Messenger flottant.
const open = ref(false)

export const useMessenger = () => ({
  open,
  show: () => { open.value = true },
  hide: () => { open.value = false },
})